/**
 * IMPORTANT:
 * - Source of truth for fonts settings.
 * - This is where we define the fonts we want to use in the app
 * - This should be imported in the apps/pages/_app.tsx file
 */

/**
 * How it works:
 * - in _app.tsx, import the objects from this file
 *   - in the html or main or style tag of the "consuming app", make sure to add the variables
 *     - for example: <main className={`${fontSans.variable} ${fontTitle.variable} ${fontBody.variable}`}>
 *     - OR for example: <style>{`${fontSans.variable} ${fontTitle.variable} ${fontBody.variable}`}</style>
 *     - 💡 the fontSans/fontTitle/fontBody.variable is the one responsible for creating the CSS variable --font-body etc.
 * - 💡 Because we are defining the font variables here and because we are using tailwind, 
 *   we can use tailwind utility classes e.g. font-title, font-body, font-sans in the component className
 * - globals.css
 *   - define the fontFamily of the body and headings
 *   - 💡 this will make it easier to re-map the fontFamily for all the consuming apps as this
 *     is the only place we need to change.
 *     -  for example: If you now want h5 and h6 to use a different fontFamily, you can do it here.
 *   - Use the fontFamily defined in the fonts.ts file.
 *     - for example: body { font-family: var(--font-body); }
 *     - for example: h1, h2, h3, h4, h5, h6 { font-family: var(--font-title); }
 * - tailwind.config.ts
 *   - 🚫 Do not extend the fontFamily here.  It will defeat the purpose of using the fonts.ts as the source of truth.
 */

import { Manrope } from 'next/font/google';

export const fontSans = {
  fontFamily: 'system-ui, sans-serif',
  variable: '--font-sans',
};

// Yes, currently our fontTitle and fontBody are the same for now.
export const fontTitle = Manrope({
  subsets: ['latin'],
  variable: '--font-title',
  fallback: ['sans-serif'],
  weight: ['400', '500', '600', '700'],
});

export const fontBody = Manrope({
  subsets: ['latin'],
  variable: '--font-body',
  fallback: ['sans-serif'],
  weight: ['400', '500', '600', '700'],
});

